export const COOKIES_TITLE = 'Мы используем cookie';
export const COOKIES_DESCRIPTION = `Продолжая пользоваться сайтом, вы соглашаетесь на обработку персональных данных в соответствии с`;
export const PRIVACY_POLICY = 'Политикой конфиденциальности';
export const TERMS_OF_USE = 'Условиях использования';

export const DIALOG_TITLES = {
  userSubscribed: 'Пользователь уже зарегистрирован',
  unfinishedRegistration: 'Подписка не оплачена',
  subscriptionExpired: 'Ваша подписка истекла.',
  cancelRegistrationStepTwo: 'Отмена оформления подписки',
  sessionExpired: 'Сессия истекла',
  signUpSessionExpired: 'Сессия истекла',
  authorizationSuccess: 'Успешная авторизация',
  abortSignUp: 'Отменить оформление подписки?'
};

export const MESSAGES = {
  userSubscribed:
    'Вы можете авторизоваться и управлять подпиской из личного кабинета.',
  unfinishedRegistration:
    'Уважаемый пользователь, Вы зарегистрированы на нашем портале, но подписка ещё не оплачена. Пожалуйста, авторизуйтесь и продолжите оформление из Личного кабинета.',
  subscriptionExpired:
    'Вы можете авторизоваться и оформить подписку из личного кабинета.',
  cancelRegistrationStepTwo: '',
  sessionExpired:
    'Похоже, ваша сессия истекла. Не переживайте, просто войдите снова, и мы сразу вернём вас в нужное место!',
  signUpSessionExpired: 'Необходимо вернуться к началу оформления подписки.',
  authorizationSuccess:
    'Ваша подписка активна, и вы успешно вошли в аккаунт. Управлять подпиской можно в Личном кабинете.',
  abortSignUpOnCreateAccountStep:
    'Если вы выйдете сейчас, данные вашей авторизации будут потеряны.',
  abortSignUpOnPaymentStep:
    'Вы ещё не завершили оплату. Если вы выйдете сейчас, подписка не будет активирована.',
  abortSignUpPrompt: 'Вы уверены, что хотите отменить оформление?'
};

export const CALLOUT_TEXTS = {
  vkIdToNewtonikAccount:
    'Ваш ID ВКонтакте будет привязан к вашему аккаунту «Ньютон и Ко».',
  signInSuccess:
    'Дорогой друг! Вы успешно авторизованы на нашем портале. Приятной работы!',
  subscriptionIsNotPayed:
    'Уважаемый пользователь, похоже вы не завершили оформление подписки — подписка не оплачена. Для доступа к полному решению задачи оплатите подписку в Личном кабинете.',
  subscriptionExpired:
    'Уважаемый пользователь, ваша подписка истекла. Для доступа к полному решению задачи оформите подписку в Личном кабинете.',
  alreadyRegistered:
    'Вы уже зарегистрированы на нашем портале! Вы можете сразу перейти к оплате или обновить свои данные, если нужно.',
  signUpSuccess:
    'Уважаемый пользователь! Ваша подписка успешно активирована, и вы авторизованы на портале. Приятной работы!',
  paymentCancelled:
    'Уважаемый пользователь, похоже вы не завершили оплату, или платёж был отклонён. Вы зарегистрированы на нашем портале и можете оплатить подписку любое время в Личном кабинете.',
  signUpSuccessSessionExpired:
    'Подписка успешно активирована, но похоже ваша сессия истекла. 😔 Не переживайте, просто войдите снова, и мы сразу вернём вас в нужное место!',
  signInFailure:
    'Уважаемый пользователь!  Похоже, у вас ещё нет аккаунта. Оформите подписку, чтобы получить полный доступ, или продолжайте пользоваться открытыми разделами!',
  allInSubscription:
    'Подписка включает в себя полный доступ ко всем разделам портала и не может быть улучшена.',
  customSubscription:
    'В настоящий момент Ваша подписка включает в себя все доступные разделы.',
  signUpSessionExpired:
    'Похоже, время на оформление подписки истекло. Не переживайте, просто начните заново — это займет всего пару минут!',
  sessionExpired:
    'Похоже, ваша сессия истекла.  Не переживайте, просто войдите снова, и мы сразу вернём вас в нужное место!',
  authorizeToGetFullContent:
    'Уважаемый пользователь, чтобы увидеть полное решение этой задачи, войдите в свой аккаунт. А если у вас ещё нет подписки, самое время её оформить — так вы получите доступ ко всем решениям и сможете учиться без ограничений!',
  maximalSubscription:
    'Уважаемый пользователь, у вас самая полная подписка, и её нельзя улучшить. Вы получаете все преимущества на нашем портале.',
  placeholderEmptyPage:
    'В настоящее время страница находится в разработке. Мы приносим свои извинения за неудобство.',
  paymentFailure:
    'К сожалению, произошла ошибка при обработке вашего платежа. Пожалуйста, убедитесь, что все данные введены правильно, и повторите попытку.',
  paymentResultPending:
    'Вы авторизованы на нашем портале и можете продолжать работу. Как только мы получим подтверждение успешной оплаты, мы активируем Вашу подписку или сообщим, если платёж неуспешен.',
  unsubscribed:
    'Похоже, вы ещё не завершили оформление, платёж не прошёл или срок подписки истёк. Чтобы получить доступ ко всем материалам — просто оплатите подписку.'
};

export const DEFAULT = {
  pageTitle: 'Страница в разработке',
  pageDescription:
    'Платформа «Ньютоник» — ваш помощник в изучении физики. Задачи с решениями для средней школы, три уровня сложности, удобный интерфейс и качественные материалы для подготовки к экзаменам и олимпиадам.'
};
